import React from "react";
import { useSelector } from 'react-redux';
import PropTypes from "prop-types";

export const ComposeDropDownBtn = ({ innerProps, children, onClick }) => {

    const { isAdmin } = useSelector((state) => state.auth);

    return (
        <div {...innerProps} className="compose-message-section">
            {children}
            {isAdmin && <button className="compose-message-btn compose-manually" onClick={() => onClick()}>
                Compose Manually
            </button>}            
        </div>
    )
}

ComposeDropDownBtn.propTypes = {
    innerProps: PropTypes.object,
    children: PropTypes.object,
    onClick: PropTypes.func
};